"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactCopyToClipboard = _interopRequireDefault(require("react-copy-to-clipboard"));
var _InlineAlert = _interopRequireDefault(require("./InlineAlert"));
var _InviteEmail = _interopRequireDefault(require("./InviteEmail"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var InviteCrew = /*#__PURE__*/function (_Component) {
  function InviteCrew(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, InviteCrew);
    _this = _callSuper(this, InviteCrew, [props]);
    _this.handleAddUserClick = _this.handleAddUserClick.bind(_this);
    _this.dismissAlert = _this.dismissAlert.bind(_this);
    _this.handleCopyClick = _this.handleCopyClick.bind(_this);
    _this.state = {
      inviteLinkMessage: 'Copy link',
      addUserButtonLoading: false,
      alert: {}
    };
    return _this;
  }
  (0, _inherits2["default"])(InviteCrew, _Component);
  return (0, _createClass2["default"])(InviteCrew, [{
    key: "resetInviteLinkState",
    value: function resetInviteLinkState() {
      var _this2 = this;
      setTimeout(function () {
        _this2.setState({
          inviteLinkStyle: {
            color: '#333'
          },
          inviteLinkMessage: 'Copy link'
        });
      }, 2000);
    }
  }, {
    key: "handleCopyClick",
    value: function handleCopyClick() {
      this.setState({
        inviteLinkMessage: 'Copied!'
      });
      this.resetInviteLinkState();
    }
  }, {
    key: "dismissAlert",
    value: function dismissAlert() {
      this.setState({
        alert: {}
      });
    }
  }, {
    key: "handleAddUserClick",
    value: function handleAddUserClick() {
      var _this3 = this;
      this.setState({
        addUserButtonLoading: true
      });
      this.props.addUserToCrew(this.props.booking).then(function (response) {
        if (response.status === 'success') {
          _this3.props.getCrewMembers(_this3.props.booking.id);
        } else {
          _this3.setState({
            alert: {
              message: response.message,
              alertType: 'danger',
              dismissible: true
            }
          });
        }
        _this3.setState({
          addUserButtonLoading: false
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;
      var _this$props = this.props,
        booking = _this$props.booking,
        inviteLink = _this$props.inviteLink,
        userInCrew = _this$props.userInCrew,
        sendCrewInvitation = _this$props.sendCrewInvitation;
      var _this$state = this.state,
        inviteLinkStyle = _this$state.inviteLinkStyle,
        inviteLinkMessage = _this$state.inviteLinkMessage,
        addUserButtonLoading = _this$state.addUserButtonLoading,
        alert = _this$state.alert;
      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_InlineAlert["default"], {
        alert: alert,
        dismissAlert: this.dismissAlert
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: "crew-invite"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "invite-methods"
      }, userInCrew === true ? '' : /*#__PURE__*/_react["default"].createElement("div", {
        className: "invite-self"
      }, /*#__PURE__*/_react["default"].createElement("button", {
        className: "btn btn--primary margin-bottom-xs ".concat(addUserButtonLoading ? 'disabled' : ''),
        onClick: function onClick() {
          return _this4.handleAddUserClick();
        }
      }, "Add yourself")), /*#__PURE__*/_react["default"].createElement(_InviteEmail["default"], {
        booking: booking,
        sendCrewInvitation: sendCrewInvitation
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: "invite-link",
        style: inviteLinkStyle
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "invite-box full-height"
      }, /*#__PURE__*/_react["default"].createElement(_reactCopyToClipboard["default"], {
        text: inviteLink,
        onCopy: function onCopy() {
          return _this4.handleCopyClick();
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "invite-link-text"
      }, inviteLinkMessage === 'Copied!' ? 'Copied!' : inviteLink))), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_reactCopyToClipboard["default"], {
        text: inviteLink
      }, /*#__PURE__*/_react["default"].createElement("button", {
        className: "btn btn--primary margin-left-md",
        onClick: function onClick() {
          return _this4.handleCopyClick();
        }
      }, inviteLinkMessage)))))));
    }
  }]);
}(_react.Component);
InviteCrew.propTypes = {
  booking: _propTypes["default"].object.isRequired,
  inviteLink: _propTypes["default"].string.isRequired,
  userInCrew: _propTypes["default"].bool.isRequired,
  addUserToCrew: _propTypes["default"].func.isRequired,
  sendCrewInvitation: _propTypes["default"].func.isRequired,
  getCrewMembers: _propTypes["default"].func.isRequired
};
var _default = exports["default"] = InviteCrew;